import { UILinkTranslation } from '../../utils'
import { useLocalizedMessages } from './useLocalizedMessages'

export const useLocalizedLinks = () => {
  const localizedLinkList = useLocalizedMessages('localizedLinkList')

  return localizedLinkList as unknown as UILinkTranslation[]
}
